"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
var _react = _interopRequireWildcard(require("react"));
var _DeviceChartContainerModule = _interopRequireDefault(require("../../styles/components/DeviceLineChart/DeviceChartContainer.module.css"));
var _moment = _interopRequireDefault(require("moment"));
var _reactMoment = _interopRequireDefault(require("react-moment"));
var _selectors = require("../../redux/selectors");
var _reactRedux = require("react-redux");
var _useGetTDisplayNameId = require("../../hooks/useGetTDisplayNameId");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const empty = _constants.yAxisTypes.empty;
const TemperatureBox = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    displayNameId = [],
    equipmentType = '',
    equipmentId = '',
    chartId = '',
    activeData = {},
    getActiveDataByType = () => {}
  } = _ref;
  const {
    tDisplayNameId = {}
  } = (0, _useGetTDisplayNameId.useGetTDisplayNameId)({
    chartId,
    equipmentType,
    equipmentId
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'flex-column'
  }, displayNameId.map(id => {
    var _tDisplayNameId$find, _tDisplayNameId$find2;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: id
    }, /*#__PURE__*/_react.default.createElement("span", null, ((_tDisplayNameId$find = tDisplayNameId.find(dId => dId.value.toString() === id)) === null || _tDisplayNameId$find === void 0 ? void 0 : _tDisplayNameId$find.label) || '--'), /*#__PURE__*/_react.default.createElement("div", {
      className: _DeviceChartContainerModule.default.temp_box
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(_DeviceChartContainerModule.default.temp_value, " ").concat(_DeviceChartContainerModule.default.multi)
    }, activeData ? !isNaN(getActiveDataByType(id).y) ? getActiveDataByType(id).y.toFixed(2) : '-' : '-'), /*#__PURE__*/_react.default.createElement("span", null, ((_tDisplayNameId$find2 = tDisplayNameId.find(dId => dId.value.toString() === id)) === null || _tDisplayNameId$find2 === void 0 ? void 0 : _tDisplayNameId$find2.unit) || '')));
  }));
}, (prev, next) => prev.displayNameId === next.displayNameId && prev.equipmentType === next.equipmentType && prev.chartId === next.chartId && _paulCorePackage.functions.areEqual(prev.activeData, next.activeData) && prev.getActiveDataByType === next.getActiveDataByType);
const InformationPanel = props => {
  var _activeSelectors$disp, _activeSelectors$disp2, _activeSelectors$disp3, _activeSelectors$y2Ax, _activeSelectors$disp4;
  const {
    chartId = '',
    equipmentType = '',
    equipmentId = ''
  } = props;
  const [time, setTime] = (0, _react.useState)('');
  const activeData = (0, _reactRedux.useSelector)(_selectors.getActiveChartData)[chartId];
  const activeSelectors = (0, _reactRedux.useSelector)(_selectors.getActiveSelectors);
  const displayNameIdList = activeSelectors === null || activeSelectors === void 0 || (_activeSelectors$disp = activeSelectors.displayNameId) === null || _activeSelectors$disp === void 0 || (_activeSelectors$disp = _activeSelectors$disp.y1Axis) === null || _activeSelectors$disp === void 0 ? void 0 : _activeSelectors$disp.concat((activeSelectors === null || activeSelectors === void 0 || (_activeSelectors$disp2 = activeSelectors.displayNameId) === null || _activeSelectors$disp2 === void 0 ? void 0 : _activeSelectors$disp2.y2Axis) || []);
  const getActiveDataByType = (0, _paulCorePackage.useDeepCallback)(id => {
    return activeData !== null && activeData !== void 0 && activeData.data.find(d => d.serieId === id.toString()) ? activeData.data.find(d => d.serieId === id.toString()).data : {};
  }, [activeData === null || activeData === void 0 ? void 0 : activeData.data]);
  const getActiveTime = (0, _paulCorePackage.useDeepCallback)(() => {
    return displayNameIdList === null || displayNameIdList === void 0 ? void 0 : displayNameIdList.reduce((acc, id) => {
      var _activeData$data$find;
      const item = activeData === null || activeData === void 0 || (_activeData$data$find = activeData.data.find(d => {
        var _d$data;
        return d.serieId === id.toString() && ((_d$data = d.data) === null || _d$data === void 0 ? void 0 : _d$data.x);
      })) === null || _activeData$data$find === void 0 ? void 0 : _activeData$data$find.data;
      return item ? item.x : acc;
    }, null);
  }, [activeData === null || activeData === void 0 ? void 0 : activeData.data, displayNameIdList]);
  (0, _react.useEffect)(() => {
    setTime(getActiveTime());
  }, [getActiveTime]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_DeviceChartContainerModule.default.temp_row, " ").concat(_DeviceChartContainerModule.default.space_around),
    style: {
      margin: '30px 0'
    }
  }, displayNameIdList !== null && displayNameIdList !== void 0 && displayNameIdList.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TemperatureBox, {
    displayNameId: (_activeSelectors$disp3 = activeSelectors.displayNameId) === null || _activeSelectors$disp3 === void 0 ? void 0 : _activeSelectors$disp3.y1Axis,
    equipmentType: equipmentType,
    equipmentId: equipmentId,
    activeData: activeData,
    chartId: chartId,
    getActiveDataByType: getActiveDataByType
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-column flex-left-center ".concat(_DeviceChartContainerModule.default.multi_time_box)
  }, /*#__PURE__*/_react.default.createElement("div", null, activeData && time ? (0, _moment.default)(time).format('DD MMM YYYY') : '-'), activeData && activeData.rangeType !== 2 ? /*#__PURE__*/_react.default.createElement("div", {
    className: _DeviceChartContainerModule.default.time
  }, time ? /*#__PURE__*/_react.default.createElement(_reactMoment.default, {
    format: 'LT'
  }, time) : '--') : null), (activeSelectors === null || activeSelectors === void 0 || (_activeSelectors$y2Ax = activeSelectors.y2AxisSelect) === null || _activeSelectors$y2Ax === void 0 ? void 0 : _activeSelectors$y2Ax.value) === empty ? null : /*#__PURE__*/_react.default.createElement(TemperatureBox, {
    displayNameId: (_activeSelectors$disp4 = activeSelectors.displayNameId) === null || _activeSelectors$disp4 === void 0 ? void 0 : _activeSelectors$disp4.y2Axis,
    equipmentType: equipmentType,
    equipmentId: equipmentId,
    activeData: activeData,
    chartId: chartId,
    getActiveDataByType: getActiveDataByType
  })) : null);
};
var _default = exports.default = InformationPanel;